import {Select} from 'antd';

import {PhotoDrawerFilterType, PhotoFilterEnum} from '../../../photo-tool-list-type';

import {SelectOptionType} from './photo-filter-form-type';

export function renderSelectOption(option: SelectOptionType): JSX.Element {
    return (
        <Select.Option key={option.id} value={option.id}>
            {option.name}
        </Select.Option>
    );
}

const PhotoDrawerFilterMap = {
    [PhotoFilterEnum.sourceIds]: 'Sources',
    [PhotoFilterEnum.statuses]: 'Statuses',
    [PhotoFilterEnum.tagIds]: 'Tags',
    [PhotoFilterEnum.timeRange]: 'Time period',
};

export function getActiveFilterTypes(filterValues: PhotoDrawerFilterType): Array<string> {
    return Object.entries(filterValues).reduce((activeFilterTypes, [key, value]) => {
        if (value.length > 0 && value[0] !== null) {
            activeFilterTypes.push(PhotoDrawerFilterMap[key as keyof PhotoDrawerFilterType]);
        }

        return activeFilterTypes;
    }, [] as Array<string>);
}
